import { Folder, Globe } from 'lucide-react'
import { useTranslation } from '@papan/i18n'

/**
 * Where a search looks: the open folder (`scoped`) or everywhere the host can
 * search. The host owns the choice and the query; this is only the control, so
 * the Drive and every picker offer the same words.
 */
export interface SearchScope {
  /** The folder a search can narrow to; null when nothing is narrower than everywhere. */
  folderName: string | null
  scoped: boolean
  onToggle: () => void
}

/** The current scope as a chip, and a link that flips it. */
export function SearchScopeControl({ scope }: { scope: SearchScope }) {
  const { t } = useTranslation('files')
  const scoped = scope.scoped && scope.folderName !== null
  return (
    <span className="inline-flex items-center gap-2 min-w-0" data-testid="search-scope">
      <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded themed-bg-tertiary themed-text-secondary min-w-0">
        {scoped
          ? <><Folder size={11} className="shrink-0" /> <span className="truncate">{scope.folderName}</span></>
          : <><Globe size={11} className="shrink-0" /> {t('driveHome.searchPage.scope.everywhere')}</>}
      </span>
      {scope.folderName !== null && (
        <button
          type="button"
          onClick={scope.onToggle}
          className="min-w-0 truncate text-indigo-400 hover:text-indigo-300 cursor-pointer"
          data-testid="search-scope-toggle"
        >
          {scoped
            ? t('driveHome.searchPage.scope.widen')
            : t('driveHome.searchPage.scope.narrow', { name: scope.folderName })}
        </button>
      )}
    </span>
  )
}
